import trLocale from 'element-ui/lib/locale/lang/tr-TR' //引入element语言包
const tr = {
  posterPage: {
    title1:'Abonelik Yakında Çevrimiçi!',
    title2:'Abonelik Yenileme, Ayrıcalıklı Yükseltme!',
    title3:'Özel indirim, yenileme daha ekonomik',
    title4:'Kodu almak için cihaz satın alan satıcıya danışabilirsiniz',
    title5:'Öncelikli deneyim özellikleri',
    function1:'Özellik Detayları:',
    function2:'Temel hizmet yenileme ücreti (aynı anda çeviri, konferans asistanı, akıllı asistan)...',
    function3:'Katma Değer Hizmetleri Aboneliği (Çevrimdışı Çeviri, Ses ve Video Çağrıları Çeviri)',
  },
  RedemptionCodePage: {
    RedemptionCode: 'Kurtarma kodu',
    ValueAddedServices: 'değer eklenmiş hizmetler',
    UpgradedExperience: 'Ekstra değer eklenmiş faydalar, geliştirilmiş deneyim',
    OfflineTranslation: 'Devre dışı çeviri',
    NoInternet: 'İnternet bağlantısı, hemen tercüme, güvenli ve güvenilir için gerek yok',
    GoToSubscribe: 'İmzala git',
    AudioAndVideoCall: 'Ses/Video Araması',
    RealTimeCall: 'Gerçek zamanlı sesin çevirimi ve iletişim erişilebilirliği',
    BaseService: 'Temel hizmetler',
    AIAssistant: 'Funksiyonlar: aynı anda yorumlama, konferans asistanı, AI asistanı',
    LanguagesSetting:'Dil Ayarları',
    languages1:'Basitleştirilmiş Çince',
    languages2:'Geleneksel Çince',
    languages3:'İngilizce',
    languages4:'Japonca',
    languages5:'Korece',
    languages6:'Rusça',
    languages7:'İspanyolca',
    languages8:'Fransızca',
    languages9:'Almanca',
    languages10:'Portekizce',
    languages11:'İtalyanca',
    languages12:'Türkçe',
    languages13:'Vietnamca',
    languages14:'Endonezyacı',
    languages15:'Hintçe',
    languages16:'Arapça',
    languages17:'Taylandça',
    languages18:'Farsça',
  },
  Login: {
    ToLogin: 'giriş',
    PhoneLogin: 'Telefon numarası ile gir',
    EmailLogin: 'E-posta giriş',
    PhonePlaceholder: 'Lütfen telefon numarasını girin.',
    EmailPlaceholder: 'Enter email',
    Code: 'Kontrol kodu',
    and: 've',
    BeforeText: 'Bir hesap oluşturmak anlaşmanızı ve uyumluluğunuzu temsil ediyor.',
    UserAgreement: 'Kullanıcı Anlaşması',
    privacy: 'Gizlilik politikası',
    errorMessage: 'Kontrol kodu hatası',
    readTitle: 'Bu anlaşmayı okuyun ve kabul edin.',
    readBefore: 'Kişisel bilgilerinizin güvenliğini sağlamak için, lütfen önce okuyun ve kabul edin.',
    cancel: 'iptal et',
    agree: 'Anlaşıldı ve devam et',
    error1:'Lütfen geçerli bir e-posta adresini girin.',
    error2:'Lütfen doğru telefon numarasını girin.',
    error3:'Kodu girin lütfen',
    success:'Başarılı Giriş'
  },
  OffLinePage: {
    title: 'Devre dışı çeviri',
    NoInternet: 'İnternet bağlantısı, hemen tercüme, güvenli ve güvenilir için gerek yok',
    ServiceLife: 'hizmet hayatı',
    forever: 'Permanent Use',
    describe: 'İmzalama İmzaları',
    describeItem1: '1. Devre dışı çeviri fonksiyonu bir kez ödeme, sürekli kullanım ve kullanma izni Bluetooth cihazına uyuyor. Eğer cihazı değiştirseniz, devre dışı çeviri koduna tekrar abone olmalısınız.',
    describeItem2: '2. Yetki kodu aboneliği geri verilmez.',
    describeItem3: '3. 10 dil desteklenir: Çince, İngilizce, Almanca, Japonca, Korece, Hintçe, Taylandça, İspanyolca, Fransızca, Rusca.',
    quantity: 'miktarda',
    payType: 'Ödeme yöntemi',
    card: 'Banka Kartı',
    wx: 'WeChat',
    GooglePay: 'Google Pay',
    subscribe: 'İmzala',
    RMB: '¥',
    confirm:'onaylayın',
    cardNumber:'Kart numarası',
    periodOfValidity:'Gıymetlik dönemi',
    safetyCode:'Güvenlik kodu',
    name:'Tam isim',
    yearAndMonth:'Yıl/Ay',
    message1:'Sayı 0 olamaz.',
    popTip:'İpuçları',
    popText1:'Lütfen dikkatlice okuyun ve anlayın.',
    popText2:'Çevrimdışı Çeviri Ücretli Sözleşme',
    popText3:'Okuyorum ve kabul ediyorum.',
    popText4:'Okuyorum ve kabul ediyorum',
  },
  AudioVideoPage: {
    title: 'Ses/Video Araması',
    RealTime: 'Gerçek zamanlı sesin çevirimi ve iletişim erişilebilirliği',
    describe: 'İmzalama İmzaları',
    describeItem1: '1. Ses ve video çağırma çeviri fonksiyonu, dakikaları yeniden yüklemek ve satın almak. Aramanın bağlantısı olduğu zamandan beri dakikalar sayısı ve izinler hesabı takip etmek. Eğer başka bir hesaba girerseniz tekrar yüklemeniz gerekiyor.',
    describeItem2: '2. Hesabı yeniden yükledikten sonra, bağlantı ve bağlama aygıtları hala her zamanki gibi kullanılabilir.',
    describeItem3: '3. Ses ve video çağrı çevirim fonksiyonu yeniden yüklenmeden sonra yeniden yüklenemez.',
    payType: 'Ödeme yöntemi',
    card: 'Banka Kartı',
    wx: 'WeChat',
    GooglePay: 'Google Pay',
    subscribe: 'İmzala',
    RMB: '¥',
    sale: 'diskont',
    confirm:'onaylayın',
    time1:'saniye',
    time2:'dakika',
    time3:'Saatler',
    time4:'Tanrım.',
    time5:'Ay',
    time6:'Yıl',
  },
  OffLineResult: {
    title1: 'Devre dışı çeviri',
    title2: 'Ses/Video Araması',
    title3: 'Temel hizmetler',
    success: 'Abunelik başarılı',
    fail: 'Abonelik başarısız oldu',
    stock:'Değişim kodu stokta',
    saveTitle: 'Ödüllendirme kodunu kurtar ve uygulamalara git onu yeniden satacak',
    code: 'Kurtarma kodu',
    tip1: 'Bu kodu sadece devre dışı çevirim fonksiyonunu yeniden düzenlemek için kullanılır',
    tip2: 'Bu kodu sadece ses/video arama çevirim fonksiyonunu yeniden düzenlemek için kullanılır',
    tip3: 'Bu kodu sadece temel servis yenileme fonksiyonlarını yeniden yayınlamak için kullanılır',
    save: 'Kaydet',
    time: 'İmzalama zamanı:',
    copy: 'kopyalama',
    copySuccess: 'Başarılı Değiştirme',
    loading:'Yükleniyor',
    paySuccess:'Ödeme başarılı'
  },
  RedemptionList: {
    title: 'Kurtarma kodu',
    view: 'Görüntü',
    time: 'İmzalama zamanı:',
  },
  MyRedemption: {
    title: 'Kurtarma kodu',
    code: 'Kurtarma kodu',
    time: 'İmzalama zamanı:',
    copy: 'kopyalama',
    tip1: 'Bu kodu sadece devre dışı çevirim fonksiyonunu yeniden düzenlemek için kullanılır',
    tip2: 'Bu kodu sadece ses/video arama çevirim fonksiyonunu yeniden düzenlemek için kullanılır',
    tip3: 'Bu kodu sadece temel servis yenileme fonksiyonlarını yeniden yayınlamak için kullanılır',
    save: 'Kaydet',
    success:"Operasyon başarılı"
  },
  basePage:{
    error1:'Ürün bilgisi bulunamadı',
    message1:'Lütfen ürün seçin',
    title:'Temel hizmetler',
    function:'Funksiyonlar: aynı anda yorumlama, konferans asistanı, AI asistanı',
    describe: 'İmzalama İmzaları',
    describe1:'1. Çevirme ve konferans yardımcısı gibi temel hizmetlerin yenilenmesinden sonra, değerlik dönemi ekipmanın ardından gelir. Eğer ekipman değiştirilirse, yenilenmesi gerekiyor.',
    describe2:'2. Temel hizmetler yenilenmeden sonra yenilenemez.',
    payType: 'Ödeme yöntemi',
    card: 'Banka Kartı',
    wx: 'WeChat',
    GooglePay: 'Google Pay',
    subscribe: 'İmzala',
    RMB: '¥',
    sale: 'diskont',
    month:'Ay',
    confirm:'onaylayın',
    month1:'1 ay',
    month2:'Yarım yıl',
    month3:'1 yıl'
  },
  ...trLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default tr;
